export default __webpack_public_path__ + "static/media/certification4.21702bcd.jpg";